import styles from './Card.module.css';

export const SkeletonCard = ({ style, registerChild }) => {
  return (
    <div className={styles.inner} style={style} ref={registerChild}>
      <div className={`hover:!bg-slate-50 ${styles.card}`}>
        <div
          className={`lg:min-w-[300px] max-list-2xl:min-h-[234px] bg-slate-200 ${styles.dummy_img}`}
        />
        <div className={styles.card_body}>
          <div className="flex items-center gap-[10px] max-lg:mb-2.5 lg:mb-3">
            <span className="bg-slate-200 h-5 w-[75px] rounded" />
            <span className="bg-slate-200 h-5 w-[103px] rounded" />
          </div>

          <div className={styles.card_body_info}>
            <div className="flex gap-2">
              <h2 className="bg-slate-200 h-5 flex-1 max-w-[250px] rounded" />
              <div className="bg-slate-200 h-5 flex-1 max-w-[170px] rounded max-list-xl:!hidden" />
            </div>
            <div className='flex flex-wrap gap-2 max-list-2xl:pt-2 list-2xl"pt-6'>
              <span className="bg-slate-200 h-2.5 w-24 rounded" />
              <span className="bg-slate-200 h-2.5 w-14 rounded" />
              <span className="bg-slate-200 h-2.5 w-8 rounded" />
              <span className="bg-slate-200 h-2.5 w-8 rounded" />
              <span className="bg-slate-200 h-2.5 w-24 rounded" />
              <span className="bg-slate-200 h-2.5 w-8 rounded" />
              <span className="bg-slate-200 h-2.5 w-8 rounded" />
              <span className="bg-slate-200 h-2.5 w-14 rounded max-list-xl:hidden" />
              <span className="bg-slate-200 h-2.5 w-8 rounded max-list-xl:hidden" />
              <span className="bg-slate-200 h-2.5 w-14 rounded max-list-xl:hidden" />
              <span className="bg-slate-200 h-2.5 w-24 rounded max-list-xl:hidden" />
              <span className="bg-slate-200 h-2.5 w-8 rounded max-list-xl:hidden" />
              <span className="bg-slate-200 h-2.5 w-24 rounded max-list-xl:hidden" />
              <span className="bg-slate-200 h-2.5 w-14 rounded max-list-xl:hidden" />
            </div>
          </div>

          <div className={styles.card_footer}>
            <div className="ml-auto flex flex-col text-right max-w-full items-end">
              <span className="bg-slate-200 h-2.5 w-28 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
